import React from 'react';
import { FiHeart, FiChevronRight } from 'react-icons/fi';
import { MdPayments } from 'react-icons/md';
import type { FavoriteService } from '../types';

interface FavoriteServicesProps {
  favorites: FavoriteService[];
  onServiceClick: (favorite: FavoriteService) => void;
  onRemove: (serviceId: string) => void;
}

const FavoriteServices: React.FC<FavoriteServicesProps> = ({
  favorites,
  onServiceClick,
  onRemove,
}) => {
  if (favorites.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl border border-pagali-gray-100 p-4">
      <div className="flex items-center gap-2 mb-4">
        <FiHeart className="text-pagali-error" />
        <h3 className="font-semibold text-pagali-gray-800">Serviços Favoritos</h3>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {favorites.slice(0, 8).map((fav) => (
          <div
            key={fav.id}
            className="relative group"
          >
            <button
              onClick={() => onServiceClick(fav)}
              className="w-full p-3 bg-pagali-gray-50 rounded-xl hover:bg-pagali-primary/10 transition-all text-center"
            >
              {fav.serviceLogo ? (
                <img
                  src={`data:${fav.serviceMimeType || 'image/png'};base64,${fav.serviceLogo}`}
                  alt=""
                  className="w-12 h-12 mx-auto rounded-lg object-contain bg-white p-1 mb-2"
                />
              ) : (
                <div className="w-12 h-12 mx-auto rounded-lg bg-white flex items-center justify-center mb-2">
                  <MdPayments className="text-xl text-pagali-gray-400" />
                </div>
              )}
              <p className="text-sm font-medium text-pagali-gray-700 truncate">
                {fav.serviceName}
              </p>
              <p className="text-xs text-pagali-gray-500 truncate">
                {fav.categoryName}
              </p>
            </button>

            {/* Remove button - visible on hover */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                onRemove(fav.serviceId);
              }}
              className="absolute -top-2 -right-2 w-6 h-6 bg-pagali-error text-white rounded-full
                         flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity
                         hover:bg-red-600 text-xs"
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FavoriteServices;
